/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import m from 'mithril';
import PubSub from 'pubsub-js';
import { runQuery, runMutation } from '../utils/fetchData';
import addProjectModal from '../pages/projects/addProjects';
import addTeamModal from '../pages/teams/addTeam';
import dataMap from '../utils/data';

import actions from '../utils/actionsMap';

import { t } from '../translation-files/translator'


const brandLogo = {
    async oninit() {
        const token = localStorage.getItem('token');

        if (!token) {
            return window.location.replace('/login');
        }
    },
    view() {
        return m(".k-aside__brand.k-grid__item.[id='k_aside_brand']",
            [
                m('.k-aside__brand-logo',
                    m('a', {
                        href: '/',
                        oncreate: m.route.link,
                        onupdate: m.route.link,
                    },
                        m("img[alt='Logo'][src='/assets/media/logos/all-white.png']", {
                            style: {
                                height: '18px',
                            },
                        }))),
                m('.k-aside__brand-tools',
                    m("button.k-aside__brand-aside-toggler.k-aside__brand-aside-toggler--left[id='k_aside_toggler']",
                        m('span'))),
            ]);
    },
};

const subMenuItem = {
    view({
        attrs,
    }) {
        const {
            onclick,
            title,
            active, icon, href,
            oncreate,
            onupdate,
            target,
        } = attrs;
        return m('li.k-menu__item', {
            class: `${active ? 'k-menu__item--active' : ''}`,
            'aria-haspopup': 'true',

        },
            m('a.k-menu__link', {
                href,
                oncreate,
                onupdate,
                onclick,
                target,
                'data-intro': attrs['data-intro'],
                'data-position': attrs['data-position'],
                'data-step': attrs['data-step'],
            },
                [
                    !icon
                        ? m('i.k-menu__link-bullet.k-menu__link-bullet--dot',
                            m('span'))
                        : m(`i.k-menu__link-icon.${icon}`),
                    m('span.k-menu__link-text',
                        title),
                ]));
    },
};

const subMenuHeader = {
    view({ attrs: { title, icon } }) {
        return m("a.k-menu__link.k-menu__toggle[href='javascript:;']",
            [
                m(`i.k-menu__link-icon.${icon}`),
                m('span.k-menu__link-text',
                    title),
                m('i.k-menu__ver-arrow.la.la-angle-right'),
            ]);
    },
};

const menuItem = {
    view({
        attrs: {
            active, title, icon, href, oncreate, onupdate, target,
        },
    }) {
        return m("li.k-menu__item.[aria-haspopup='true']", {
            class: `${active ? 'k-menu__item--active' : ''}`,
            'aria-haspopup': 'true',
        },
            m('a.k-menu__link', {
                href,
                oncreate,
                onupdate,
                target,
            },
                [
                    m(`i.k-menu__link-icon.${icon}`),
                    m('span.k-menu__link-text',
                        title),
                ]));
    },
};

const sectionHeader = {
    view({ attrs: { title } }) {
        return m('li.k-menu__section.',
            [
                m('h4.k-menu__section-text',
                    title),
                m('i.k-menu__section-icon.flaticon-more-v2'),
            ]);
    },
};

export default {
    async oninit({ state }) {
        Object.assign(state, {
            projects: [],
            teams: [],
        });

        PubSub.subscribe(actions.UPDATE_PROJECT, (msg, { id, name }) => {
            const oldProject = state.projects.filter(project => project.id === id)[0];
            oldProject.name = name;

            Object.assign(state, {
                projects: [...state.projects.filter(project => project.id !== id), oldProject],
            });

            m.redraw();
        });

        PubSub.subscribe(actions.UPDATE_TEAM, (msg, { id, name }) => {
            const oldTeam = state.teams.filter(team => team.id === id)[0];
            oldTeam.name = name;

            Object.assign(state, {
                teams: [...state.teams.filter(team => team.id !== id), oldTeam],
            });

            m.redraw();
        });

        PubSub.subscribe(actions.DELETE_PROJECT, async (msg, { id }) => {
            Object.assign(state, {
                projects: state.projects.filter(project => project.id !== id),
            });
        });

        PubSub.subscribe(actions.DELETE_TEAM, async (msg, { id }) => {
            Object.assign(state, {
                teams: state.teams.filter(team => team.id !== id),
            });
            m.redraw();
        });

        const client = await dataMap.getClientData();

        Object.assign(state, client);
        m.redraw();

        // listen for a new client
        PubSub.subscribe(actions.CLIENT_VIEW_CHANGE, async (msg) => {
            const client = await dataMap.getClientData();

            Object.assign(state, client);
            m.route.set('/');
            m.redraw();
        });
    },

    view({ state, attrs }) {
        return [m("div", {
            "class": "card",
            style: {
                boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)'
            }
        },
            [

                m("div", { "class": "card-header border-0 pt-6" }, [
                    attrs.overideHeader == true ? attrs.customHeader : [
                        m("div", { "class": "card-title" }, [
                            m("card-label.fw-bold.text-grey-900.fs-2x.mb-3", attrs.title)
                        ]),
                        m("div", { "class": "card-toolbar" },
                            [
                                m("div", { "class": "d-flex align-items-center position-relative my-1", style: { "padding-right": "30px" } },
                                    [
                                        m("i", { "class": "ki-duotone ki-magnifier fs-3 position-absolute ms-5" },
                                            [
                                                m("span", { "class": "path1" }),
                                                m("span", { "class": "path2" })
                                            ]
                                        ),
                                        m("input", { "class": "form-control w-250px ps-12", "type": "text", "data-kt-customer-table-filter": "search", "placeholder": t().common.search + " " + attrs.title })
                                    ]
                                ),
                                attrs.actionItems,
                                // m("div", { "class": "d-flex justify-content-end align-items-center d-none", "data-kt-customer-table-toolbar": "selected" },
                                //     [
                                //         m("div", { "class": "fw-bold me-5" },
                                //             [
                                //                 m("span", { "class": "me-2", "data-kt-customer-table-select": "selected_count" }),
                                //                 "Selected "
                                //             ]
                                //         ),
                                //         m("button", { "class": "btn btn-danger", "type": "button", "data-kt-customer-table-select": "delete_selected" },
                                //             "Delete Selected"
                                //         )
                                //     ]
                                // )
                            ]
                        )
                    ],

                ]),
                m("div", { "class": "card-body pt-0" }, [
                    attrs.overideHeader ==true ? m('div', [
                        m("div", { "class": "card-title" }, [
                            m("card-label.fw-bold.text-grey-900.fs-2x.mb-3",attrs.title)
                        ]),
                    ]) : null,
                    m(".table-responsive.table-loading", [
                        // m("div", { "class": "table-loading-message" },
                        //     " Loading... "
                        // ),
                        m("table", { "class": "table align-middle table-row-dashed fs-6 gy-5", "id": "kt_customers_table" },
                            [
                                m("thead",
                                    m("tr", { "class": "text-start text-gray-800 fw-bold fs-7 text-uppercase gs-0" },
                                        [
                                            attrs.dataConfigs.disableSelection === true ? null : m("th", { "class": "w-10px pe-2" },
                                                m("div", { "class": "form-check form-check-sm form-check-custom form-check-solid me-3" },
                                                    m("input", { "class": "form-check-input", "type": "checkbox", "data-kt-check": "true", "data-kt-check-target": "#kt_customers_table .form-check-input", "value": "1" })
                                                )
                                            ),
                                            attrs.dataConfigs.dataMapping.map(({ label, style }) => {
                                                return m("th", { "class": "min-w-10px" }, label)
                                            }),
                                            attrs.dataConfigs.disableActions === true ? null : m("th", { "class": "text-end min-w-70px" },
                                                t().journey_plan.plans_table_labels.actions,
                                            )
                                        ]
                                    )
                                ),
                                m("tbody", { "class": "fw-semibold text-gray-800" }, attrs.dataConfigs.dataRows.map(data => {
                                    return m("tr",
                                        [
                                            attrs.dataConfigs.disableSelection === true ? null : m("td",
                                                m("div", { "class": "form-check form-check-sm form-check-custom form-check-solid" },
                                                    m("input", { "class": "form-check-input", "type": "checkbox", "value": "1" })
                                                )
                                            ),
                                            ...attrs.dataConfigs.dataMapping.map(config => {
                                                const { style, render } = config
                                                return m("td", { style }, typeof render === 'function' ? render(data) : data[config.data_key]);
                                            }),
                                            attrs.dataConfigs.disableActions === true ? null : m("td", { "class": "text-end" },
                                                m("div", { "class": "btn-group", "role": "group", "aria-label": "Basic example" }, [
                                                    m("a", {
                                                        "class": "btn btn-sm btn-light btn-flex btn-center btn-active-light-primary", onclick(e) {
                                                            e.preventDefault();
                                                            attrs.view()
                                                        }
                                                    },
                                                        [
                                                            // "Actions ",
                                                            m("i", { "class": "bi bi-eye fs-5 ms-1" })
                                                        ]
                                                    ),

                                                    attrs.dataConfigs.disabeEditing == true ? null : m("a", {
                                                        "class": "btn btn-sm btn-light btn-flex btn-center btn-active-light-primary", onclick(e) {
                                                            e.preventDefault();
                                                            attrs.edit()
                                                        }
                                                    },
                                                        [
                                                            // "Actions ",
                                                            m("i", { "class": "bi bi-pen fs-5 ms-1" })
                                                        ]
                                                    ),

                                                    attrs.dataConfigs.disableDeletion == true ? null : m("a", {
                                                        "class": "btn btn-sm btn-light btn-flex btn-center btn-active-light-primary", onclick(e) {
                                                            e.preventDefault();
                                                            attrs.delete()
                                                        }
                                                    },
                                                        [
                                                            // "Actions ",
                                                            m("i", { "class": "bi bi-x fs-3", "style": { "color": "red" } })
                                                        ]
                                                    ),
                                                ])
                                            )
                                        ]
                                    )
                                })

                                )
                            ]
                        )])
                ])
            ]
        )]
    },
};


